
import React from "react";

import ExportLogs from "../component/ExportLogs";

const ExportLogsContainer = () => (<ExportLogs />)

export default ExportLogsContainer; 